import makeStyles from '@mui/styles/makeStyles';

export const tradeStyles = makeStyles((theme) => ({
  formControl: {
    position: 'relative',
    width: '100%',
  },
  chipContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',

    '& .MuiChip-root': {
      marginRight: 5,
      marginBottom: 2.5,
      marginTop: 2.5,

      '& .MuiIcon-root': {
        fontSize: '1.2rem'
      }
    }
  },
  inlineModal: {
    '& .MuiIconButton-root': {
      borderRadius: 4,

      '& .MuiIcon-root': {
        fontSize: 16,
        width: 'auto',
        height: 'auto',
      }
    }
  },
  tradeMarker: {
    position: 'absolute',
    top: p => p.isIOS ? -170 : -40,
    left: 0,
  },
  hidden: {
    display: 'none',
  },
}));
